export class AppSettings
{
    version: string;
    constructor()
    {
        this.version = "1.10.0";
    }
};